
import axios from 'axios'
import React from 'react'
import localStorage from 'localStorage'
import Select from 'react-select';
import { ROLE } from '../services/Macro';
import { AuthApi, ROOT } from '../services/Api';
import { encrypUtil } from '../utils/EncrypUtil';
import { Page } from '../services/Page';

export default class Header extends React.Component {
    state = {
        options: [
            { value: 'zh_CN', label: '简体中文' },
            { value: 'en_US', label: 'English' },
        ]
    }

    handleLogout = () => {
        // 通知服务器移除token
        this.notifyLogout()
        localStorage.removeItem('token')
    }

    notifyLogout = async () => {
        const DEBUG = true
        const TAG = `Header.notifyLogout() - `

        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || 'zh_CN'
        const requestData = {
            token: token,
            lang: lang.split('_')[0]
        }
        DEBUG && console.log(TAG, `requestData:\n`, requestData)
        let params = await encrypUtil.encodeRequestRsa(requestData)
        DEBUG && console.log(TAG, `params:\n`, params)
        const api = AuthApi.LOGOUT
        const response = await axios.post(api, params)
        DEBUG && console.log(TAG, `账号登出:\n`, response.data.data)
        // 跳转到登录页面
        window.location.href = `${ROOT}/${Page.login}`
    }

    changeLanguage = (lang) => {
        const { i18n } = this.props
        i18n.changeLanguage(lang)
    }

    /** 多语言切换 */
    handleLang = (selectedOption) => {
        const lang = selectedOption.value
        console.log('lang:', lang)
        localStorage.setItem('lang', lang)
        this.setState(selectedOption)
        this.changeLanguage(lang)
        this.props.changeLang()
    }

    toggleSidebar = () => {
        console.log(`开关手机浏览器侧边栏`)

        // 在 html 上增减一个 sidebar-left-opened 样式
        const html = document.getElementsByTagName("html")[0]
        console.log(html);
        if (html.classList.contains('sidebar-left-opened')) {
            html.classList.remove('sidebar-left-opened')
        }
        else {
            html.classList.add('sidebar-left-opened')
        }
    }

    getRoleName(role) {
        let t = this.props.trans
        switch (role) {
            case ROLE.SUPER:
                return t('admin')
            // case ROLE.AGENT:
            //     return t('agent')
            default:
                return t('normalUser')
        }
    }

    render() {
        let t = this.props.trans
        let options = this.state.options
        let lang = localStorage.getItem('lang') || "zh_CN"
        let selectedOption = options[0]
        if (lang === "en_US") selectedOption = options[1]

        let role = Number(localStorage.getItem('role')) || ROLE.SUPER
        let roleStr = this.getRoleName(role)

        return (
            <header className="header">
                <div className="logo-container">
                    <a href="./" className="logo">
                        <img src="./assets/images/logo.png" height="35" alt="Porto Admin" />
                    </a>
                    <div className="visible-xs toggle-sidebar-left"
                        data-toggle-class="sidebar-left-opened"
                        data-target="html"
                        data-fire-event="sidebar-left-opened"
                        onClick={this.toggleSidebar}>
                        <i className="fa fa-bars" aria-label="Toggle sidebar"></i>
                    </div>
                </div>

                <div className="col-sm-7 text-right"></div>
                <div className="col-sm-2 text-right">
                    <Select value={selectedOption} options={options} onChange={this.handleLang} />
                </div>
                <span className="separator"></span>

                <div className="header-right">

                    <div id="userbox" className="userbox">
                        <a href="#" data-toggle="dropdown">
                            <figure className="profile-picture">
                                <img src="./assets/images/!logged-user.jpg" alt="Joseph Doe" className="img-circle" data-lock-picture="./assets/images/!logged-user.jpg" />
                            </figure>
                            <div className="profile-info" data-lock-name="John Doe" data-lock-email="johndoe@okler.com">
                                <span className="name">{this.props.loginName}</span>
                                <span className="role">{roleStr}</span>
                            </div>

                            <i className="fa custom-caret"></i>
                        </a>

                        <div className="dropdown-menu">
                            <ul className="list-unstyled">
                                <li className="divider"></li>
                                <li>
                                    {/* <a role="menuitem" href={ROOT} onClick={this.handleLogout}><i className="fa fa-power-off"></i>{t('logout')}</a> */}
                                    <a role="menuitem" onClick={this.handleLogout}><i className="fa fa-power-off"></i>{t('logout')}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}